import { BASE_URL } from 'constants/api';
import actions from './index';

import { createPostAPI } from '@cuemath/rest-api';

export const ACTIONS = {
  GET: 'CONFIGS_GET',
  GET_SUCCESS: 'CONFIGS_GET_SUCCESS',
  GET_FAILURE: 'CONFIGS_GET_FAILURE',
};

export const get = actions.get(key => `${BASE_URL}/configs/${key}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

const { usePost: useConfigPost } = createPostAPI({
  getURL: _ => `${BASE_URL}/configs/aws-signed-key`,
});

export { useConfigPost };
